module.exports = __webpack_public_path__ + "static/beauty-catalogue-section-code-215d71c3c87f1bdf85b554741a61ac32.png";